module.exports = __webpack_public_path__ + "static/img/12.b844be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/12.png
// module id = PX//
// module chunks = 1